<template>
  <div class="nps-list">
    <div class="search-row">
      <InputCommon
        id="nps-search"
        class="search-input"
        label="Rechercher un commanditaire ou un bénéficiaire"
        placeholder="SNCF Gare"
        v-model="search_input"
      />
      <slot name="filters" />
    </div>
    <div class="nps-header nps-row">
      <p>Date</p>
      <p>Commanditaire</p>
      <p>Bénéficiaire</p>
      <p>Note (0 à 10)</p>
    </div>
    <div class="cards" :class="{ loading }">
      <CommonLoader v-if="loading" class="loader" />
      <CompositeNpsCard
        v-for="item in items"
        :key="item.interventionId"
        :item="item"
        @open="(id) => emits('open', id)"
      />
      <p v-if="!loading && items.length === 0" class="empty">Aucune note NPS.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { watchDebounced } from '@vueuse/core'
import CommonLoader from '@/components/common/CommonLoader.vue'
import InputCommon from '@/components/common/input/InputCommon.vue'
import CompositeNpsCard from './CompositeNpsCard.vue'
import type { NpsResultItem } from 'types/api/nps'

defineProps<{
  items: NpsResultItem[]
  loading?: boolean
}>()

const emits = defineEmits<{
  (e: 'open', interventionId: number): void
  (e: 'search', search: string): void
}>()

const search_input = ref('')

watchDebounced(search_input, (value) => emits('search', value.trim()), { debounce: 300 })
</script>

<style scoped lang="scss">
.nps-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.search-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.search-input {
  flex: 1;
}

@media screen and (min-width: 640px) {
  .search-row {
    flex-direction: row;
    align-items: flex-end;
  }
}

.nps-row {
  display: grid;
  grid-template-columns: var(--nps-columns, 130px 2fr 2fr 1fr 40px);
  align-items: center;
  gap: 10px;
}

.nps-header {
  padding: 0 21px;
}

.nps-header > p {
  color: var(--vc-dark);
  font-weight: 500;
}

.cards {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Pendant un chargement, les cards restent en place (estompées) pour que la
   hauteur de la page ne bouge pas et que le scroll ne saute pas. */
.cards.loading {
  min-height: 60px;
  pointer-events: none;
}

.cards.loading > :not(.loader) {
  opacity: 0.4;
}

.empty {
  color: rgba(var(--vcrgb-dark), 0.75);
  text-align: center;
  padding: 20px 0;
}

.loader {
  position: absolute;
  inset: 0;
  margin: auto;
  color: var(--vc-dark);
}
</style>
